import React from 'react';
import { Box, Typography } from '@mui/material';

import PrimaryButton from '../../../Layouts/MaterialUi/PrimaryButton';

import LazyImage from '../../../Layouts/LazyImage';
import Link from '../../../Layouts/ActiveLink';

import style from './style';

interface LearnerProfileInterface {
  data?: any;
  isProfilePage?: boolean;
}

const LearnerProfile = ({ data, isProfilePage }: LearnerProfileInterface) => {
  const classes = style();

  return (
    <Box className={classes.profileBox}>
      <LazyImage
        radius={'50%'}
        sizes={sizes}
        quality={85}
        alt={data?.firstName + ' ' + data?.lastName}
        className={classes.learnerImg}
        src={`/images/courses/learners/${data?.img}`}
      />
      <div>
        <Link href={`/community/${data?.profile_url}`}>
          <Box display="flex" alignItems="center">
            <Typography variant="h5">
              {data?.firstName + ' ' + data?.lastName}
            </Typography>
            <div style={{ marginLeft: 15 }}>
              <img
                style={{ width: '30px' }}
                src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${data?.flag}.svg`}
                alt={data?.country}
              />
            </div>
          </Box>
        </Link>
        <Typography className="text-light-blue" gutterBottom variant="body1">
          {`Novatr ${data?.graduate_date}`}
        </Typography>

        {data?.designation &&
          data?.designation.map((designation, key) => (
            <Typography className="line-height1-2" key={key} variant="body1">
              {designation}
            </Typography>
          ))}
        {!isProfilePage && (
          <Box mt={'12px'} display={{ xs: 'none', md: 'block' }}>
            <Link href={`/community/${data?.profile_url}`}>
              <>
                <PrimaryButton variant="outlined">
                  check out profile
                </PrimaryButton>
              </>
            </Link>
          </Box>
        )}
      </div>
    </Box>
  );
};

const sizes = {
  xxl: [180, 180, false],
};

export default LearnerProfile;
